import Reflux from 'reflux';
import EventData from 'shared/data/Event';
import UserData from 'shared/data/User';

let async = { asyncResult: true },
  CuesheetTrackingActions = Reflux.createActions({
    populateShowCallers: async,
    updateTrackableCue: async,
    clearTrackableCue: {},
    clearTrackableCuePersistent: async,
    updateTrackingUser: async,
    clearTracking: async,
    selectTrackableUser: {},
    toggleTrackingEnabled: {},
    resumeTrackingPosition: {},
    setInitialTrackingPosition: {},
  });

CuesheetTrackingActions.populateShowCallers.listenAndPromise(
  (teamId, eventId) => EventData.getRolesByType(teamId, eventId, 'showCaller'),
);

CuesheetTrackingActions.updateTrackableCue.listenAndPromise(
  UserData.updateTrackableCue,
);

CuesheetTrackingActions.clearTrackableCuePersistent.listenAndPromise(
  UserData.clearTrackableCue,
);

CuesheetTrackingActions.updateTrackingUser.listenAndPromise(
  UserData.updateTrackingUser,
);

CuesheetTrackingActions.clearTracking.listenAndPromise(UserData.clearTracking);

export default CuesheetTrackingActions;
